import React from "react"
// eslint-disable-next-line react/no-deprecated
import {render} from "react-dom"
import {Router} from "react-router-dom"

import {MsalProvider} from "@azure/msal-react"
import History from "@irati/utils/history"
import {ThemeProvider} from "@irati/ui/src/global/useTheme"
import {PRODUCTION, STAGING} from "@irati/utils/constants/environment"
import {StyleSheetManager} from "styled-components"
import isPropValid from "@emotion/is-prop-valid"
import {logBanner, sendSlackConsoleComms} from "@irati/utils/console/banner"
import coview from "@irati-web/platform/src/utils/coview"
import env from "@irati/utils/env"

// various 3rd parties
import sentry from "@irati/utils/services/sentry"
import ga4Tracking from "@irati-web/tracking"
import {msalInstance} from "@irati-web/platform/src/utils/microsoftapis/index"
import {getClarityID} from "@irati/utils/microsoftClarity"
import domain from "@irati/utils/env/domain"
import "@irati/utils/intercom"
import "@irati/braze"
import Clarity from "@microsoft/clarity"
import {setupStore} from "./redux/setupStore"
import App from "./routes/index"

// Global css
import "react-table/react-table.css"
import "../public/css/react-table.css"
import "react-redux-toastr/lib/css/react-redux-toastr.min.css"
import {setupPhraseWindowFn} from "./phrase"
import "react-material-symbols/dist/outlined.css"

if ([STAGING, PRODUCTION].indexOf(env.ENVIRONMENT_NAME) > -1) {
  /** Console log logo banner when in pipeline for hires */
  window.hireMe = sendSlackConsoleComms
  logBanner()
}

coview.setup()
ga4Tracking.init()
setupStore()
setupPhraseWindowFn()

if (!domain.isInternal()) {
  Clarity.init(getClarityID())
}

sentry.context(() => {
  /** Start the app */

  render(
    <MsalProvider instance={msalInstance()}>
      <Router history={History}>
        <ThemeProvider>
          <StyleSheetManager
            shouldForwardProp={(propName, target) => {
              return typeof target === "string" ? isPropValid(propName) : true
            }}>
            <App />
          </StyleSheetManager>
        </ThemeProvider>
      </Router>
    </MsalProvider>,
    document.getElementById("root")
  )
  if (module.hot) module.hot.accept()
})

// Handle outlines for mouse / keyboard users
document.body.addEventListener("keyup", function (e) {
  if (e.which === 9) {
    /* tab */
    document.documentElement.classList.remove("no-focus-outline")
  }
})

document.body.addEventListener("mousedown", function () {
  document.documentElement.classList.add("no-focus-outline")
})
